<template>
<div class="newsList">
    <div class="top-box">
        <div class="bg" :style="{backgroundImage: `url(${image})`}">
            <navTop></navTop>
            <div class="banner-box">
                新闻动态
            </div>
        </div>
    </div>
    <div class="btns-list">
        <div :class="{'btns-child':true,'active-btn':item.isClick}" v-for="(item,index) in btnsList" :key="index">{{item.text}}</div>
    </div>
    <div class="newsList-box">
        <div class="newsList-content">
            <div class="child-news" v-for="(item,index) in newsList" :key="index">
                <div class="left-child">
                    <div class="left-text">
                        <div class="left-title">{{item.title}}</div>
                        <div class="left-texts">{{item.text}}</div>
                        <div class="more-text" @click="goDetails"><span>Explore more</span>
                            <img src="../assets/images/default_go.png" alt="" width="20px" height="16px" class="default-img">
                            <img src="../assets/images/active_go.png" alt="" width="20px" height="16px" class="active-img">
                        </div>
                    </div>
                    <div class="imgs-box">
                        <img :src="item.icon" alt="" width="100%" height="100%">
                    </div>
                </div>
                <div class="right-child">
                    <div class="date">{{item.date}}</div>
                    <div class="year">{{item.year}}</div>
                </div>
            </div>

        </div>
    </div>
    <div class="pages">
        <div class="pages-content">
            <div class="go-pages">
                <div class="btns-child">首页</div>
                <div class="btns-child">1</div>
                <div class="btns-child">2</div>
                <div class="btns-child">3</div>
                <div class="btns-child">下一页</div>
                <div class="btns-child">末页</div>
            </div>
            <div class="total-pages">
                <div class="num-pages">共234页</div>
                <div class="num-pages">每页5条</div>
                <div class="num-pages">当前第1页</div>
                <div class="num-pages">跳转至 &nbsp;<input type="text" width="10%" class="input-box">&nbsp; 页</div>
            </div>
        </div>

    </div>
    <div class="footer-box">
        <div class="footer-top">
            <div class="child-info">
                客服热线：028-8335-5593<br>
                （工作日09:00~18:00）
            </div>
            <div class="child-info">
                商务合作：service@scitcs.com<br>
                （工作时段2小时内回复）
            </div>
            <div class="child-info">
                公司地址：成都市高新区天泰路<br>112号四川投资大厦15楼北
            </div>
        </div>
        <div class="footer-bottom">
            <div class="bottom-left">
                <div class="com">四川省外综云服科技有限公司</div>
                <div class="addr"><span>Copyright©2019 &nbsp;</span><span>版权所有 &nbsp; 四川资阳跨界贸易有限服务公司</span>&nbsp;&nbsp;&nbsp;&nbsp; <span>承办单位:四川省外综云服科技有限公司</span></div>
                <div class="info">蜀公网安备 蜀ICP备2021002738号-1</div>
            </div>
            <div class="bottom-right">
                <div class="img-box">
                    <img src="../assets/images/qrcode.jpg" alt="" width="98px" height="98px">
                    <div class="text-qrcode">关注外综云服</div>
                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
import navTop from '@/components/navTop'
import {ossUrl} from "@/utils/config"
export default {
    name: "newsList",
    components: {
        navTop
    },
    data() {
        return {
            image:ossUrl+'/bg_5.png',
            btnsList: [{
                id: 0,
                text: "新闻动态",
                isClick: true,
            }, {
                id: 1,
                text: "政策通知",
                isClick: false,
            }],
            newsList: [{
                id: 0,
                title: "加强学习领会习近平生态文明思想，持续提升新区生态文明建设水平！",
                year: "2021",
                date: "08.28",
                text: "8月26日下午，四川天府新区党工委副书记、成都科学城党工委书记邱旭东带队前往华阳街道，调研天府新区入河排口情况。邱旭东一行来到南湖东路桥上游130米府河左岸城镇雨洪排口，现场听取了排口日常管…",
                icon: require("../assets/images/cross-icon.png")
            }, {
                id: 1,
                title: "加强学习领会习近平生态文明思想，持续提升新区生态文明建设水平！",
                year: "2021",
                date: "08.28",
                text: "8月26日下午，四川天府新区党工委副书记、成都科学城党工委书记邱旭东带队前往华阳街道，调研天府新区入河排口情况。邱旭东一行来到南湖东路桥上游130米府河左岸城镇雨洪排口，现场听取了排口日常管…",
                icon: require("../assets/images/cross-icon.png")
            }, {
                id: 3,
                title: "加强学习领会习近平生态文明思想，持续提升新区生态文明建设水平！",
                year: "2021",
                date: "08.28",
                text: "8月26日下午，四川天府新区党工委副书记、成都科学城党工委书记邱旭东带队前往华阳街道，调研天府新区入河排口情况。邱旭东一行来到南湖东路桥上游130米府河左岸城镇雨洪排口，现场听取了排口日常管…",
                icon: require("../assets/images/cross-icon.png")
            }, {
                id: 4,
                title: "加强学习领会习近平生态文明思想，持续提升新区生态文明建设水平！",
                year: "2021",
                date: "08.28",
                text: "8月26日下午，四川天府新区党工委副书记、成都科学城党工委书记邱旭东带队前往华阳街道，调研天府新区入河排口情况。邱旭东一行来到南湖东路桥上游130米府河左岸城镇雨洪排口，现场听取了排口日常管…",
                icon: require("../assets/images/cross-icon.png")
            }]
        }
    },
    methods: {
        goDetails() {
            this.$router.push("/newsDetails")
        }
    }
}
</script>

<style lang="less" scoped>
.input-box {
    width: 20px;
    padding: 0 5px;
    text-align: center;
}

.newsList {
    width: 100%;
    height: 100%;

    .top-box {
        height: 800px;
        display: flex;
        flex-direction: column;
        background-color: #06162F;

        //border:1px red solid;
        .bg {
            width: 100%;
            height: 100%;
            //border:1px red solid;
            //border:1px red solid;
            background-position: center center;
            background-size: cover;
            background-repeat: no-repeat;
        }

        .banner-box {
            display: flex;
            //width: 100%;
            flex: 1;
            //border:1px red solid;
            padding-left: 240px;
            padding-top: 300px;
            font-size: 60px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 84px;
        }

    }

    .btns-list {
        height: 50px;
        background-color: #0650C5;
        padding-left: 240px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-top: 15px;
        padding-bottom: 15px;

        .btns-child {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            //border:1px red solid;
            margin-right: 80px;
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.5);
            line-height: 22px;
        }
    }

    .newsList-box {
        width: 100%;
        //height: 100%;
        display: flex;
        justify-content: center;

        .newsList-content {
            width: 1440px;
            display: flex;
            //border: 1px red solid;
            flex-direction: column;
            padding-top: 80px;
        }

        .child-news {
            width: 100%;
            border-top: 2px #200000 solid;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            .left-child {
                width: 80%;
                //height: 100%;
                padding: 50px 0;
                display: flex;
                flex: 1;
                justify-content: space-between;
                align-items: flex-start;

                .imgs-box {
                    width: 400px;
                    height: 328px;
                }

                .left-text {
                    width: 50%;
                    height: 100%;

                    .left-title {
                        font-size: 24px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                        line-height: 33px;
                        margin-bottom: 43px;
                    }

                    .left-texts {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #666666;
                        line-height: 25px;
                        margin-bottom: 107px;
                    }

                    .more-text {
                        font-size: 14px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #999999;
                        line-height: 20px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;

                        .default-img {
                            display: block;
                        }

                        .active-img {
                            display: none;
                        }
                    }
                }

                //border: 1px red solid;
            }

            .right-child {
                width: 20%;
                //height: 100%;
                padding: 50px 0;
                //border: 1px red solid;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: flex-end;

                .year {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #000000;
                    line-height: 20px;
                }

                .date {
                    font-size: 36px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #000000;
                    line-height: 50px;
                }
            }

            &:last-child {
                border-bottom: 2px #200000 solid;
            }
        }

        .child-news:hover {
            width: 100%;
            border-top: 2px #200000 solid;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            .left-child {
                width: 80%;
                //height: 100%;
                padding: 50px 0;
                display: flex;
                flex: 1;
                justify-content: space-between;
                align-items: flex-start;

                .imgs-box {
                    width: 400px;
                    height: 328px;
                    position: relative;
                    left: -50px;
                }

                .left-text {
                    width: 50%;
                    height: 100%;

                    .left-title {
                        font-size: 24px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #CC1F37;
                        line-height: 33px;
                        margin-bottom: 43px;
                    }

                    .left-texts {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #666666;
                        line-height: 25px;
                        margin-bottom: 107px;
                    }

                    .more-text {
                        font-size: 14px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #CC1F37;
                        line-height: 20px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;

                        .default-img {
                            display: none;
                        }

                        .active-img {
                            display: block;
                        }
                    }
                }

                //border: 1px red solid;
            }

            .right-child {
                width: 20%;
                //height: 100%;
                padding: 50px 0;
                //border: 1px red solid;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: flex-end;

                .year {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #000000;
                    line-height: 20px;
                }

                .date {
                    font-size: 36px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #000000;
                    line-height: 50px;
                }
            }

            &:last-child {
                border-bottom: 2px #200000 solid;
            }
        }
    }

    .pages {
        width: 100%;
        //height: 100%;
        margin-bottom: 120px;
        padding-top: 120px;
        display: flex;
        justify-content: center;

        .pages-content {
            width: 1440px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            padding: 30px 0;
        }

        .go-pages {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .btns-child {
                width: 78px;
                height: 42px;
                background: #FFFFFF;
                border: 1px solid #CCCCCC;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 14px;

                &:last-child {
                    margin-right: 0px;
                }
            }

            //border: 1px red solid;
        }

        .total-pages {
            width: 100%;
            margin-top: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            //border: 1px red solid;

            .num-pages {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 20px;
                margin-right: 10px;

            }
        }

        //border:1px red solid;
    }

    .footer-box {
        width: 100%;
        //height: 300px;
        //border: 1px red solid;

        .footer-top {
            //width: 100%;
            padding: 0 360px;
            height: 88px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: white;
            background-color: #021233;
            border-bottom: 1px rgba(255, 255, 255, 0.1) solid;

            .child-info {
                font-size: 13px;
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 16px;
            }
        }

        .footer-bottom {
            //width: 100%;
            height: 188px;
            padding: 0 360px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .bottom-left {
                width: 80%;
                display: flex;
                justify-content: center;
                align-items: flex-start;
                flex-direction: column;
                height: 100%;

                .com,
                .addr,
                .info {
                    margin-bottom: 30px;
                    font-size: 14px;
                    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 21px;
                }
            }

            .bottom-right {
                width: 20%;
                height: 100%;
                display: flex;
                justify-content: flex-end;
                align-items: flex-start;
                text-align: center;

                .img-box {
                    width: 100px;
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    padding-top: 30px;
                    flex-direction: column;
                    text-align: center;
                    //border: 1px red solid;

                    .text-qrcode {
                        width: 100%;
                        font-size: 14px;
                        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 21px;
                    }
                }

            }

            background-color: #021233;
        }
    }
}

.active-btn {
    color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/views/newsList.vue